<div *ngIf="product" class="my-3">
  <h5>{{ 'rrs.productDescription.productDetails' | cxTranslate }} -</h5>
  <h6 class="mb-3">
    {{ 'rrs.productDescription.skuNumber' | cxTranslate }}: {{ product.code }}
  </h6>
  <div [innerHTML]="product.description"></div>
</div>
